import { createState, Downgraded, useHookstate, useState } from '@hookstate/core'
import { Broadcasted as broadcasted } from '@hookstate/broadcasted'
import { Id, toast } from 'react-toastify'
import { useEffect } from 'react'
import { useNotificationCenter } from 'react-toastify/addons/use-notification-center'

interface INotification {
  readonly notification: number | null;
  readonly currentIdNotification: number | null;
}

export const notificationDefault: number | null = null
export const clearNotificationDefault: boolean | null = null
export const clearUniqueNotificationDefault: boolean | null = null
export const currentIdNotificationDefault: number | null = null

const notificationStore = Object.create(notificationDefault)
const clearNotificationsStore = createState<boolean | null>(clearNotificationDefault)
const clearUniqueNotificationStore = createState<boolean | null>(clearUniqueNotificationDefault)
const currentIdNotificationStore = currentIdNotificationDefault

const store = createState<INotification>({
  notification: notificationStore,
  currentIdNotification: currentIdNotificationStore 
})

clearNotificationsStore.attach(broadcasted('clear-notification-events'))
clearUniqueNotificationStore.attach(broadcasted('clear-unique-notification-events'))
store.attach(broadcasted('notification-events'))

export default function useNotificationState() {
  const actualNotification = useState<number|null>(store.notification)
  const clearNotifications = useHookstate(clearNotificationsStore)
  const clearUniqueNotification = useHookstate(clearUniqueNotificationStore)
  const currentIdNotification = useState(store.currentIdNotification)

  useEffect(() => {
    if (actualNotification.get()) {
      toast.dismiss(actualNotification.get() as Id)
    }
  }, [actualNotification.get()])

  const handleClearNotification = () => {
    clearNotifications.set(!clearNotifications.get())
  }

  const handleClearUniqueNotification = () => {
    clearUniqueNotification.set(!clearUniqueNotification.get())
  }

  return {
    actualNotification: () => actualNotification,
    currentIdNotification: () => currentIdNotification,
    handleClearNotification: () => handleClearNotification(),
    clearNotifications: () => clearNotifications,
    handleClearUniqueNotification: () => handleClearUniqueNotification(),
    clearUniqueNotification: () => clearUniqueNotification,
  }
}
